import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSiteInfo } from "@/hooks/useSiteInfo";

export default function CtaBanner() {
  const { t } = useTranslation();
  const site = useSiteInfo();

  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-2xl bg-foreground-950 text-background-50">
          <div className="absolute inset-0 opacity-25">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20navy%20industrial%20engineering%20scene%20with%20black%20rubber%20parts%20and%20metal%20molds%20arranged%20on%20engineering%20blueprint%2C%20dramatic%20side%20lighting%2C%20premium%20B2B%20manufacturing%20visual%2C%20deep%20shadows%2C%20editorial%20product%20photography%2C%20wide%20panoramic%20composition&width=1800&height=900&seq=krubber-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/85 to-foreground-950/40" />

          <div className="relative px-7 md:px-14 py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse" />
                <span className="text-[11px] tracking-[0.22em] uppercase text-background-50/85 font-semibold">
                  {t("home.cta.eyebrow")}
                </span>
              </div>
              <h2 className="mt-6 font-heading font-extrabold text-3xl md:text-[44px] leading-[1.15] tracking-tight">
                {t("home.cta.headline1")}
                <br />
                <span className="text-accent-300">{t("home.cta.headline2")}</span>
              </h2>
              <p className="mt-5 text-base md:text-lg text-background-50/80 leading-relaxed max-w-2xl">
                {t("home.cta.desc")}
              </p>

              <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t("home.cta.contactBtn")}
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </Link>
                <a
                  href={site.telLink}
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border border-background-50/30 text-background-50 hover:bg-background-50/10 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line" />
                  </span>
                  TEL · {site.tel}
                </a>
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="rounded-xl bg-background-50/8 backdrop-blur-md border border-background-50/15 p-6">
                <div className="text-[11px] tracking-[0.2em] uppercase text-background-50/60 font-semibold">
                  {t("home.cta.quickContact")}
                </div>
                <ul className="mt-4 flex flex-col gap-4">
                  <li className="flex items-start gap-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                      <i className="ri-phone-fill" />
                    </span>
                    <div className="flex flex-col">
                      <span className="text-[11px] text-background-50/55 uppercase tracking-widest">
                        {t("home.cta.phone")}
                      </span>
                      <a
                        href={site.telLink}
                        className="text-sm font-semibold text-background-50 hover:text-accent-300 cursor-pointer"
                      >
                        {site.tel}
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                      <i className="ri-mail-fill" />
                    </span>
                    <div className="flex flex-col">
                      <span className="text-[11px] text-background-50/55 uppercase tracking-widest">
                        {t("home.cta.email")}
                      </span>
                      <a
                        href={site.emailLink}
                        className="text-sm font-semibold text-background-50 hover:text-accent-300 cursor-pointer break-all"
                      >
                        {site.email}
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                      <i className="ri-time-fill" />
                    </span>
                    <div className="flex flex-col">
                      <span className="text-[11px] text-background-50/55 uppercase tracking-widest">
                        {t("home.cta.hours")}
                      </span>
                      <span className="text-sm font-semibold text-background-50">
                        {t("home.cta.hoursValue")}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}